import { VehicleOutput } from '@allocab/allocab-driver-service-types';
import { getPanelNameLabelByKey } from '@allocab/allocab-shared-utils';

import { t } from '../../services/translation/translation';
import { formatDate, parseDate } from '../../utils/date';
import { getEngineTypeText } from '../../utils/vehicle';

type Props = {
  vehicle: Pick<VehicleOutput, 'color' | 'panelKeys' | 'firstDate' | 'engineType'>;
};

export const VehicleInfo = ({ vehicle }: Props) => {
  return (
    <div>
      <p className="space-x-2">
        <span className="text-xs font-normal text-gray-500 dark:text-gray-400 uppercase">{t('common.color')}</span>
        <span className="inline-block capitalize">{vehicle.color?.toLowerCase() ?? '--'}</span>
      </p>
      <p className="space-x-2">
        <span className="text-xs font-normal text-gray-500 dark:text-gray-400 uppercase">
          {t('vehicle-route.elligible-panels')}
        </span>
        <span>{vehicle.panelKeys?.map(p => getPanelNameLabelByKey(p)).join(', ') ?? '--'}</span>
      </p>
      <p className="space-x-2">
        <span className="text-xs font-normal text-gray-500 dark:text-gray-400 uppercase">{t('common.first-date')}</span>
        <span>
          {vehicle.firstDate ? formatDate(parseDate(vehicle.firstDate, 'DD-MM-YYYY'), t('date.date-short')) : '--'}
        </span>
      </p>
      <p className="space-x-2">
        <span className="text-xs font-normal text-gray-500 dark:text-gray-400 uppercase">
          {t('common.engine-type')}
        </span>
        <span>{vehicle.engineType ? getEngineTypeText(vehicle.engineType) : '--'}</span>
      </p>
    </div>
  );
};
